import { render, staticRenderFns } from "./FindABusiness.vue?vue&type=template&id=194579a2&scoped=true"
import script from "./FindABusiness.vue?vue&type=script&lang=ts"
export * from "./FindABusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194579a2",
  null
  
)

export default component.exports